import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../../shared/media-query';
import JournalModal from './journal';
import AccountNotExistsModal from './account-not-exists';
import LoginModal from './login';
import PasswordModal from './password';
import ProfileModal from './profile';
import SignupModal from './signup';
import SMSModal from './sms';
import VIPUnsubscribe from './vip-unsubscribe';

class Component extends BaseComponent {
    constructor() {
        super();
        this.dialog;
        this.devcat = MQ.isMobile() ? 'Mobile' : 'Desktop';
    }

    getCtx = () => {
        if (this.props.signupIntent && this.props.signupIntent.ctx) {
            return this.props.signupIntent.ctx;
        }
        return typeof window !== 'undefined' && window.location && window.location.href
            ? (window.location.href.includes('readings-reports') ? 'reading' : 'nav')
            : 'nav';
    }

    documentEscapeListener = (e) => {
        if (e.keyCode == 27 && this.props.route == 'password') {
            e.preventDefault();
            document.location.href = '/';
        }
    }

    escapeListener = async (e) => {
        if (e.keyCode == 27) {
            e.preventDefault();
            await this.close('x');
        }
    }

    clickListener = async (e) => {
        if (e.target.tagName == 'DIALOG') {
            await this.close('outside');
        }
    }

    componentDidMount() {
        document.addEventListener('keydown', this.documentEscapeListener);

        this.dialog.addEventListener('keydown', this.escapeListener);

        this.dialog.addEventListener('mousedown', this.clickListener);

        if ([
            'account-not-exists',
            'journal',
            'login',
            'password',
            'signup',
            'sms',
        ].includes(this.props.route)) {
            this.dialog.showModal();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.documentEscapeListener);

        this.dialog.removeEventListener('keydown', this.escapeListener);

        this.dialog.removeEventListener('mousedown', this.clickListener);
    }

    shouldComponentUpdate(nextProps) {
        if (!nextProps.autoLogin && nextProps.route == 'password') {
            this.dialog.close();
            this.props.routeTo('');
            return false;
        }

        if (nextProps.route == '') {
            if ([
                'account-not-exists',
                'journal',
                'login',
                'profile',
                'signup',
                'sms',
                'vip-unsubscribe',
            ].includes(this.props.route)) {
                this.dialog.close();
            }
        }

        if (nextProps.route != this.props.route) {
            if (this.props.route == 'password' && nextProps.autoLogin) {
                this.props.routeTo('password');
                return false;
            }

            return true;
        }

        return false;
    }

    render() {
        return (
            <modal>
                <dialog ref={el => this.dialog = el}>
                    {this.renderChild()}
                </dialog>
            </modal>
        );
    }

    completeSignupFlow = () => {
        // Centralized function to complete signup flow and clear product.pending
        // Called when signup modal is closed in step 3 or 4
        if (this.props.product && this.props.product.pending) {
            this.props.updateProduct({
                pending: false,
            });
        }
    }

    renderChild = () => {
        if (this.props.route) {
            let ChildModal = null;

            if (this.props.route == 'account-not-exists') {
                ChildModal = AccountNotExistsModal;
            } else if (this.props.route == 'journal') {
                ChildModal = JournalModal;
            } else if (this.props.route == 'login') {
                ChildModal = LoginModal;
            } else if (this.props.route == 'password') {
                ChildModal = PasswordModal;
            } else if (this.props.route == 'profile') {
                ChildModal = ProfileModal;
            } else if (this.props.route == 'signup') {
                ChildModal = SignupModal;
            } else if (this.props.route == 'sms') {
                ChildModal = SMSModal;
            } else if (this.props.route == 'vip-unsubscribe') {
                ChildModal = VIPUnsubscribe;
            }

            if (ChildModal) {
                if (this.dialog && !this.dialog.open) {
                    window.hideSMVideoUnit();
                    this.dialog.showModal();
                }

                return (<ChildModal close={this.close} onModeChange={(mode) => { this.signupMode = mode; }} />);
            }
        }

        return null;
    }


    close = async (source = 'x', mode = null) => { // eslint-disable-line complexity
        let ga4_info = `SiteInteraction:${this.props.route.charAt(0).toUpperCase()}${this.props.route.slice(1)}`;

        // Get signup mode if not provided (for backward compatibility)
        const signupMode = mode !== null ? mode : (this.signupMode || null);

        // Check if we're closing a signup modal and show abandonment confirm
        // Skip abandonment modal for steps 3 and 4
        if (this.props.route === 'signup' && signupMode !== 3 && signupMode !== 4) {
            const shouldClose = await this.showSignupAbandonmentConfirm();
            if (!shouldClose) {
                return false; // Don't close, user chose to continue
            }
        }

        // Handle GA4 events for steps 3 and 4
        let skipRegularTrackEvent = false;
        if (this.props.route === 'signup' && signupMode === 3) {
            const eventName = source === 'outside' ? 'interest_outside_modal_close' : 'interest_close';
            this.props.trackCustomEvent({
                event_name: eventName,
                params: {
                    devcat: this.devcat,
                    ctx: this.getCtx(),
                },
            });
            skipRegularTrackEvent = true;

            // Complete signup flow when closing modal in step 3
            this.completeSignupFlow();
        } else if (this.props.route === 'signup' && signupMode === 4) {
            const eventName = source === 'outside' ? 'sms_outside_modal_close' : 'sms_close';
            this.props.trackCustomEvent({
                event_name: eventName,
                params: {
                    devcat: this.devcat,
                    ctx: this.getCtx(),
                },
            });
            skipRegularTrackEvent = true;

            // Complete signup flow when closing modal in step 4
            this.completeSignupFlow();
        }

        if (this.props.route == 'password' && this.props.autoLogin) {
            document.location.href = '/';
            return false;
        } else if (this.props.route == 'sms') {
            this.props.updateProduct({
                pending: false,
            });
            ga4_info = 'SiteInteraction:SMS';
        } else if (this.props.route == 'vip-unsubscribe') {
            ga4_info = 'SiteInteraction:VIP-Unsubscribe';
        }

        // Only send regular trackEvent if not handling steps 3 or 4
        if (!skipRegularTrackEvent) {
            this.props.trackEvent([
                'Close',
                ga4_info,
            ]);
        }

        this.props.routeTo('');

        window.showSMVideoUnit();

        return true;
    }

    showSignupAbandonmentConfirm = () => {
        // Track the abandonment attempt
        this.props.trackEvent(['Open', 'SiteInteraction:SignupAbandonment']);

        // Create a custom confirm dialog as a child of the dialog element
        return new Promise((resolve) => {
            const overlay = document.createElement('div');
            overlay.className = 'signup-abandonment-overlay';

            overlay.innerHTML = `
                <div class="signup-abandonment-dialog">
                    <div class="signup-abandonment-title">Don't leave your path unfinished.</div>
                    <div class="signup-abandonment-message">
                        In just one step, you'll join a community of seekers who 
                        <strong>unlock daily insights, guidance,</strong> and 
                        <strong>cosmic clarity.</strong>
                    </div>
                    <div class="signup-abandonment-buttons">
                        <button class="signup-abandonment-btn primary" 
                                onclick="window.signupAbandonmentContinue()">
                            Complete My Signup
                        </button>
                        <a href="#" class="signup-abandonment-link" 
                           onclick="window.signupAbandonmentLeave(); return false;">
                            Maybe later
                        </a>
                    </div>
                </div>
            `;

            // Create global functions for the buttons
            window.signupAbandonmentContinue = () => {
                handleInteraction('continue');
            };

            window.signupAbandonmentLeave = () => {
                handleInteraction('leave');
            };

            // Add event listeners
            const handleInteraction = (action) => {
                if (action === 'continue') {
                    this.props.trackEvent(['Click', 'SiteInteraction:SignupAbandonment_ContinueSignup']);
                    // Remove overlay from dialog
                    if (this.dialog && overlay.parentNode === this.dialog) {
                        this.dialog.removeChild(overlay);
                    } else {
                        document.body.removeChild(overlay);
                    }

                    resolve(false); // Don't close
                } else if (action === 'leave') {
                    this.props.trackEvent(['Click', 'SiteInteraction:SignupAbandonment_LeaveSignup']);
                    // Remove overlay from dialog
                    if (this.dialog && overlay.parentNode === this.dialog) {
                        this.dialog.removeChild(overlay);
                    } else {
                        document.body.removeChild(overlay);
                    }

                    resolve(true); // Close
                }
            };

            overlay.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const action = e.target.getAttribute('data-action');

                if (action) {
                    handleInteraction(action);
                } else if (e.target === overlay) {
                    // Clicked outside dialog - treat as continue
                    handleInteraction('continue');
                }
            });

            // Add keyboard support
            const handleKeyDown = (e) => {
                if (e.key === 'Escape') {
                    handleInteraction('continue');
                }
            };

            document.addEventListener('keydown', handleKeyDown);

            // Clean up when dialog is removed
            const originalRemoveChild = document.body.removeChild;
            document.body.removeChild = function(element) {
                if (element === overlay) {
                    document.removeEventListener('keydown', handleKeyDown);
                    delete window.signupAbandonmentContinue;
                    delete window.signupAbandonmentLeave;
                    document.body.removeChild = originalRemoveChild;
                }
                return originalRemoveChild.call(this, element);
            };

            // Add to dialog element instead of body
            if (this.dialog) {
                this.dialog.appendChild(overlay);
            } else {
                document.body.appendChild(overlay);
            }
        });
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
    autoLogin: state.user && state.user.auto_login,
    product: state.product,
    signupIntent: state['signup-intent'],
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (route) => dispatch({ type: 'route:to', payload: route }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackCustomEvent: (payload) => dispatch({ type: 'ga:custom_event', payload: payload }),
    updateProduct: (payload) => dispatch({ type: 'product:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
